import React from 'react';
import { useBranch } from '../contexts/BranchContext';
import { useTimeFrame } from '../contexts/TimeFrameContext';
import AppLayout from './AppLayout';

interface DeviceAwareLayoutProps {
  children: React.ReactNode | ((props: any) => React.ReactNode);
}

const DeviceAwareLayout: React.FC<DeviceAwareLayoutProps> = ({ children }) => {
  const { selectedBranch } = useBranch();
  const { timeFrame: selectedPeriod } = useTimeFrame();
  const selectedBrand = selectedBranch
    ? { id: selectedBranch.brandId, name: '', logo: '' }
    : null;

  if (typeof children === 'function') {
    return (
      <AppLayout>
        {children({ selectedBrand, selectedBranch, selectedPeriod })}
      </AppLayout>
    );
  }

  return <AppLayout>{children}</AppLayout>;
};

export default DeviceAwareLayout;
